module.exports = __webpack_public_path__ + "ebce53f1eb3a04047ba962baf39baed3.png";